// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M6 1.5C7.933 1.5 9.5 3.067 9.5 5C9.5 6.58536 8.44553 7.92311 7 8.35352V10H14V8H22V14H14V12H7V18H14V16H22V22H14V20H5V8.35352C3.55447 7.92311 2.5 6.58536 2.5 5C2.5 3.067 4.067 1.5 6 1.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chart-draw-io-filled')
export default class ChartDrawIoFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chart-draw-io-filled',
    }
  }
}
